import React, { useEffect, useMemo, useState } from 'react';
import { Vault } from 'data/Vaults';
import styled from '@emotion/styled';
import {
	Box,
	FormControlLabel,
	Switch,
	SwitchProps,
	Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { THEME_COLOR, TOKEN } from 'data/constant';
import DistributionHistoryModal from 'pages/NewDashboard/components/DistributionHistory';
import { listOfAllDistribution } from 'apis';
import { AccountType, DistributionEvent } from 'types/distribution';
import { useAptosWalletContext } from 'context/aptosProvider';

const Card = styled('div', {
	shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled: boolean }>`
	border-radius: 8px;
	width: 100%;
	overflow: hidden;
	height: 100%;
	display: flex;
	flex-direction: column;

	:hover {
		cursor: ${(props) => (!props.disabled ? 'pointer' : 'no-drop')};
	}
`;

const Row = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const Header = styled(Row)`
	width: 100%;
	background: ${THEME_COLOR};
	justify-content: space-between;
`;

const Body = styled('div')`
	padding: 16px 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const Item = styled(Row)`
	//background: {THEME_COLOR};
	justify-content: space-between;
	margin-bottom: 9px;
	border-radius: 4px;
`;

const IOSSwitch = styled((props: SwitchProps) => (
	<Switch
		disableRipple
		focusVisibleClassName=".Mui-focusVisible"
		{...props}
	/>
))({
	width: 32,
	height: 19,
	padding: 0,
	'& .MuiSwitch-switchBase': {
		padding: 0,
		margin: 1,
		transitionDuration: '300ms',
		'&.Mui-checked': {
			transform: 'translateX(12px)',
			color: '#fff',
			'& .MuiSwitch-thumb': {
				backgroundColor: '#fff',
			},
			'& + .MuiSwitch-track': {
				backgroundColor: '#275FF1',
				opacity: 1,
				border: 0,
			},
		},
		'&.Mui-disabled .MuiSwitch-thumb': {
			color: '#aaa',
		},
		'&.Mui-disabled + .MuiSwitch-track': {
			opacity: 0.5,
		},
	},
	'& .MuiSwitch-thumb': {
		boxSizing: 'border-box',
		width: 16,
		height: 16,
		backgroundColor: '#fff',
	},
	'& .MuiSwitch-track': {
		borderRadius: 10,
		backgroundColor: '#c5c5c5',
		opacity: 1,
		transition: 'background-color 300ms',
	},
});

export const ItemCard: React.ComponentType<
	Vault & { accountInformation: AccountType | null }
> = ({ accountInformation, ...props }) => {
	const [lifetimePoints, setLifetimePoints] = useState(true);
	const [open, setOpen] = useState(false);
	const [listDistribution, setListDistribution] = useState<
		DistributionEvent[]
	>([]);
	/*const [accountInformation, setAccountInformation] =
		useState<AccountType | null>(null);*/
	const appVault = useSelector((state: RootState) => state.vault);
	const selectedVault = useSelector((state: RootState) => state.vault);
	const selectedContract = selectedVault.exchanger.find(
		(d) => d.value === appVault.exchange,
	);
	const { account } = useAptosWalletContext();

	const tokenData = useMemo(() => {
		return (
			(lifetimePoints
				? accountInformation?.tokens?.sort(
						(a, b) => b.lifetimePNL - a.lifetimePNL,
				  )
				: accountInformation?.tokens?.sort(
						(a, b) => b.amount - a.amount,
				  )
			)?.slice(0, 3) || []
		);
	}, [accountInformation?.tokens, lifetimePoints]);

	useEffect(() => {
		async function fetchListDistribution() {
			const stats = await listOfAllDistribution({
				address: account || '',
				contract: selectedContract?.depositContractAddress || '',
			});
			setListDistribution(stats);
		}

		fetchListDistribution().catch(console.log);
	}, [
		account,
		selectedContract?.depositContractAddress,
		setListDistribution,
	]);

	/*	useEffect(() => {
		async function fetchAccountInformation() {
			const res = await getUserAccountInformation({
				address: address?.toLowerCase() || '',
				contract:
					selectedContract?.depositContractAddress?.toLowerCase() ||
					'',
			});
			setAccountInformation(res);
		}

		fetchAccountInformation().catch(console.log);
	}, [address, selectedContract?.depositContractAddress]);*/

	return (
		<>
			<Card disabled={!props.isActive}>
				<Header>
					<Row
						style={{
							width: '100%',
							justifyContent: 'space-between',
						}}
					>
						<Typography variant={'subtitle1'} fontWeight={500}>
							Account Information
						</Typography>
						<FormControlLabel
							control={
								<IOSSwitch
									defaultChecked
									onClick={() =>
										setLifetimePoints(!lifetimePoints)
									}
								/>
							}
							label={lifetimePoints ? 'Lifetime' : 'Balance'}
							sx={{
								'& .MuiFormControlLabel-label': {
									fontSize: '14px',
									marginLeft: 1,
								},
							}}
						/>
						{/*<Typography
							variant={'subtitle2'}
							fontWeight={500}
							color={'#275FF1'}
							style={{
								cursor: 'pointer',
								textDecoration: 'underline',
							}}
							onClick={() => setOpen(true)}
						>
							Distribution History
						</Typography>*/}
					</Row>
				</Header>
				<Box height={8} />
				{/*<Row style={{ justifyContent: 'start', paddingLeft: 14 }}>
					<FormControlLabel
						control={
							<IOSSwitch
								defaultChecked
								onClick={() =>
									setLifetimePoints(!lifetimePoints)
								}
							/>
						}
						label={lifetimePoints ? 'Lifetime' : 'Balance'}
						sx={{
							'& .MuiFormControlLabel-label': {
								fontSize: '14px',
								marginLeft: 1,
							},
						}}
					/>
				</Row>*/}
				{/*{accountInformation && (*/}
				<Body>
					<div>
						<Item>
							<Typography variant={'caption'} fontWeight={400}>
								Total point accumulated
							</Typography>
							<Typography variant={'caption'} fontWeight={500}>
								{parseFloat(
									`${
										lifetimePoints
											? accountInformation?.points
													?.lifetimePoints || '0'
											: accountInformation?.points
													?.amount || '0'
									}`,
								).toFixed(3)}
							</Typography>
						</Item>
						<Box height={10} />
						<Item>
							<Typography
								variant={'caption'}
								fontSize={12}
								fontWeight={500}
								color={'#8A8C92'}
							>
								CURRENT{' '}
								{lifetimePoints
									? 'LIFETIME REWARDS'
									: 'BALANCE'}
							</Typography>
						</Item>
						{tokenData.map((d, i) => (
							<Item key={i}>
								<Typography variant={'caption'}>
									{d.tokenName}
								</Typography>
								<Row style={{ alignItems: 'center' }}>
									<img
										src={TOKEN[d.tokenName]?.url}
										width={18}
										height={18}
										alt={TOKEN[d.tokenName]?.url}
									/>
									<Box width={5} />
									<Typography variant={'caption'}>
										{parseFloat(
											`${
												lifetimePoints
													? d.lifetimePNL
													: d.amount
											}`,
										).toFixed(3)}
									</Typography>
								</Row>
							</Item>
						))}
						<Box height={10} />
					</div>
					<Typography
						variant={'subtitle2'}
						fontWeight={500}
						color={'#275FF1'}
						style={{
							cursor: 'pointer',
							alignSelf: 'end',
							textDecoration: 'underline',
						}}
						onClick={() => setOpen(true)}
					>
						Distribution History
					</Typography>
				</Body>
				{/*)}*/}
				{/*{!accountInformation && (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							minHeight: 200,
						}}
					>
						<Typography
							alignSelf={'center'}
							variant={'subtitle1'}
							justifySelf={'center'}
						>
							You have not earned any rewards yet.
						</Typography>
					</div>
				)}*/}
			</Card>
			<DistributionHistoryModal
				onClose={() => {
					setOpen(false);
				}}
				open={open}
				listDistribution={listDistribution}
			/>
		</>
	);
};
